import { Box, FormHelperText } from "@mui/material";
import { IEnhancedDropDown, IEnhancedDropDownItem } from "@websential/cosmic-v20";
import Select, { GroupBase, OptionProps, components } from "react-select";

import { JSX } from "react/jsx-runtime";
import React from "react";

const color = "#0057db";

const customStyles = {
  // ✅ The dropdown options
  option: (provided: any, state: any) => ({
    ...provided,
    // backgroundColor: state.isDisabled
    //   ? "rgba(0, 0, 0, 0.06)"
    //   : state.data?.process
    //     ? "#E5FFE8" // light green for processed
    //     : "#fff",

    backgroundColor: state.isDisabled
    ? "rgba(0, 0, 0, 0.06)"
    : state.isSelected
      ? provided.backgroundColor // ← keep default selected color
      : state.data?.process
        ? "#E5FFE8" // processed
        : "#fff",
    color: state.isSelected ? "#fff" : "#000",
    ":hover": {
      backgroundColor: state.data?.process ? "#D7FFD9" : "#f5f5f5",
      color:"#000"
      // backgroundColor: "#f5f5f5",
    },
  }),

  // ✅ The control (input box)
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: "#fff",
    borderColor: "#c3c4c4",
    minHeight: "3em",
    borderRadius: "2px",
    ":hover": {
      borderColor: "#000",
    },
  }),

  // ✅ The selected value shown in control
  singleValue: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.data?.process ? "#E5FFE8" : "#fff",
    padding: "2px 4px",
    borderRadius: "2px",
  }),

  container: (provided: any) => ({
    ...provided,
    fontFamily: ["Roboto", "sans-serif"].join(","),
    fontSize: ".8125rem",
    fontWeight: 500,
    lineHeight: "1rem",
  }),

  multiValue: (styles: any) => ({
    ...styles,
    backgroundColor: "#deebff",
  }),
  multiValueLabel: (styles: any) => ({
    ...styles,
    color: color,
    fontSize: "16px",
  }),
  multiValueRemove: (styles: any) => ({
    ...styles,
    color: color,
    ":hover": {
      backgroundColor: "#d8e6fb",
      color: color,
    },
  }),
};

const Option = (props: JSX.IntrinsicAttributes & OptionProps<unknown, boolean, GroupBase<unknown>> | any) => {
  return (
    <div>
      <components.Option {...props}>
        {props.label !== "--" && (
          <>
            <input
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
              style={{ accentColor: "#0057db" }}
            />{" "}
          </>
        )}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

/**
 * Select Input control for ReactJS with multiselect,
 * autocomplete, async and creatable support.
 */
export const ProcessPayrollDropDown: React.FC<IEnhancedDropDown | any> = ({
  selectName,
  items,
  selectedItem,
  showEmpty,
  isClearable,
  isSearchable,
  isMulti,
  isLoading,
  isDisabled,
  isHide,
  onChangeHandler,
  testId,
  helperText,
}) => {
  // const classes = useStyles();
  const getItems = (
    options: IEnhancedDropDownItem[],
    isEmpty?: Boolean,
    multiEnable?: Boolean
  ) => {
    if (
      isEmpty &&
      options &&
      options.length > 0 &&
      options[0].value !== "" &&
      !multiEnable
    ) {
      let emptyOption = { value: "", label: "--" };
      options.splice(0, 0, emptyOption);
    }
    options.map((item, index) => ({
      index: item.value,
      value: {
        ...item,
        toString: () => index, // assumes item has a unique id property
      },
      label: item.label,
    }));
    return options;
  };

  const getMultiSelected = (options: IEnhancedDropDownItem[] | any) => {
    let arr: IEnhancedDropDownItem[] = [];
    options.forEach((option: any) => {
      for (let i in selectedItem) {
        if (option && option.value === selectedItem[i]) {
          arr.push(option);
        }
      }
    });
    return arr;
  };

  /**
   * this returns the value of the select input by:
   *
   * 1. If there is a selected value, it will return its option.
   * 2. If there is no selected value (undefined) e.g. when we
   *    reset the form, it will be empty string which reflects in
   *    the UI instead of undefined.
   *
   * @param {IEnhancedDropDownItem[]} options
   * @returns {IEnhancedDropDownItem | string}
   */
  const getSingleSelectValue = (
    options: IEnhancedDropDownItem[]
  ): IEnhancedDropDownItem | string | any => {
    if (selectedItem === undefined || selectedItem === null) return null;
    if (selectedItem.length === 0) return "";

    return options.find((option) => {
      return option && option.value === selectedItem;
    });
  };

  const renderDDL = () => {
    return (
      <>
        {isHide ? null : (
          <Box className="dropDownWrapper">
            <Select
              key={selectName}
              options={getItems(items, showEmpty, isMulti)}
              value={
                isMulti ? getMultiSelected(items) : getSingleSelectValue(items)
              }
              components={
                isMulti
                  ? {
                    Option,
                    IndicatorSeparator: () => null,
                  }
                  : {
                    IndicatorSeparator: () => null,
                  }
              }
              hideSelectedOptions={false}
              isClearable={isClearable}
              isSearchable={isSearchable}
              inputId={testId}
              name={selectName}
              isMulti={isMulti}
              isLoading={isLoading}
              isDisabled={isDisabled}
              onChange={onChangeHandler}
              // allowSelectAll={true}
              styles={customStyles}
              closeMenuOnSelect={!isMulti}
              classNamePrefix="dropDownField"
            />
            <FormHelperText
              sx={{
                margin: "4px 14px 0 0px",
              }}
              error
              role="alert"
            >
              {helperText}
            </FormHelperText>
          </Box>
        )}
      </>
    );
  };

  return renderDDL();
};
